type ReadWriteCount = {
  reads?: number;
  writes?: number;
};

type ReadWriteCountForResult<T> = ReadWriteCount | ((result: T) => ReadWriteCount);

const totalsByScreen = new Map<string, Required<ReadWriteCount>>();

export const recordReadWriteCount = (screen: string, count: ReadWriteCount): void => {
  if (!import.meta.env.DEV) return;

  const totals = totalsByScreen.get(screen) ?? { reads: 0, writes: 0 };
  totals.reads += count.reads ?? 0;
  totals.writes += count.writes ?? 0;
  totalsByScreen.set(screen, totals);
  console.debug(`[Firestore ${screen}]`, {
    operation: count,
    total: { ...totals }
  });
};

export const withReadCounter = async <T>(
  screen: string,
  operation: () => Promise<T>,
  count: ReadWriteCountForResult<T>
): Promise<T> => {
  const result = await operation();
  const operationCount = typeof count === 'function' ? count(result) : count;
  recordReadWriteCount(screen, operationCount);
  return result;
};
